module.exports = __webpack_public_path__ + "2cc70832a9625a46c5af736a46b21bb7.woff2";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSans-bold.woff2
// module id = 3557
// module chunks = 39